import React from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";
export default function Banner1() {
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",

            alignItems: "center",
          }}
        >
          <div
            style={{
              padding: isMobile ? "20px 40px" : "40px 150px",
            }}
          >
            <p className="body-lg m-0 text-center">
              {" "}
              <span className="accent-text">Kritika Goswamy Malik&nbsp;</span>
              stands as a luminary in high-end residential interior design. With
              an unwavering passion for crafting bespoke interiors and an
              uncompromising commitment to aesthetic excellence, Over the course
              of two decades, she has honed her expertise, seamlessly blending
              sophistication with functionality to curate timeless living
              spaces. A postgraduate in Interior Design, Kritika's global
              exposure has shaped her ability to source exceptional décor and
              furniture, bringing a distinctive elegance to every project she
              undertakes.
            </p>
            <br />
            <br />
            <p className="body-lg m-0 text-center">
              Her design philosophy—
              <span className="accent-text">
                &nbsp;"Functionality meets aesthetics"&nbsp;
              </span>
              —guides her approach, ensuring that every space she creates is not
              only visually striking but also thoughtfully tailored to the
              lifestyles of her discerning clientele. Beyond design, she is
              deeply invested in educating clients about the nuances of style,
              proportion, and technical precision, fostering a deeper
              appreciation for well-conceived interiors.
            </p>
          </div>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
